import { isPointInPolygon } from "../../utils/selectionAreas";
import type { IsInsideFeedArea } from "./types";

export const isInsideFeedArea: IsInsideFeedArea = ({ point, area }) =>
  isPointInPolygon({ point, ring: area.polygon });
